import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Typography } from 'antd';

import NotificationCard from './NotificationCard';

import SubscriptionHelper from '../../pages/auth/helpers/subscription.helper';
import { selectCurrentSubscription } from '../../pages/account/billing/store/billingSettings.selectors';

import { selectDarkMode, selectUserOrganization } from '../../../userBrowserSettings/store/browserSettings.selectors';
import { getThemeColorClass } from '../../../utils/helpers/themeHelpers';

const classes = {
    warningNotification: 'optimizer-date-warning-notification',
    infoNotification: 'optimizer-info-notification',
    title: 'title',
};

const GeneralNotificationComponent = () => {
    const darkMode = useSelector(selectDarkMode);
    const location = useLocation();
    const organization = useSelector(selectUserOrganization);
    const subscription = useSelector(selectCurrentSubscription);

    const notificationSettings = JSON.parse(process.env.REACT_APP_GENERAL_NOTIFICATION_SETTINGS || '{}');
    const isTrial = SubscriptionHelper.isTrial(subscription, organization)

    return (notificationSettings.showGeneralNotification
        && (
            location.pathname.endsWith(notificationSettings.showGeneralNotificationOnlyOnRoute)
            || !notificationSettings.showGeneralNotificationOnlyOnRoute)
        && (
            (notificationSettings.showGeneralNotificationOnlyPaidUsers && !isTrial)
            || !notificationSettings.showGeneralNotificationOnlyPaidUsers)
    ) && (
        <div
            className={notificationSettings.isWarning ? `${classes.warningNotification}` : `${classes.infoNotification}`}
        >
            <NotificationCard
                content={(
                    <Typography className={`${classes.title} ${getThemeColorClass(darkMode)}`}>
                        <span dangerouslySetInnerHTML={{ __html: notificationSettings.generalNotificationText }}></span>
                    </Typography>
                )}
            />
        </div>
    );
};

export default GeneralNotificationComponent;